import useI18n from 'i18n/useI18n';
import React, { useEffect, useState, useMemo } from 'react';
import {
    getProcessedCategories,
    getProcessedSubcategoriesWithOptions,
} from 'pages/MenuItems/utils/transformers';
import useCategories from 'state/categories';
import { Dropdown } from '@etiquette-ui/inputs-dropdowns';
import styled from 'styled-components';
import useFilters from 'state/filters';
import useTranslatedFilterSelect from 'hooks/useTranslatedFilterSelect';

const FiltersContainer = styled.div`
    display: flex;
    align-items: start;
    gap: 10px;

    .filter-dropdown {
        width: 250px;

        .dropdown-module_inputContainer__25Hsy {
            flex-wrap: nowrap;
        }

        .selector__single-value{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 165px;
        }
    }
`;

const Filters = ({ data, setList}) => {
    const { translate } = useI18n();
    const [categories] = useCategories();    
    const [filters, filtersDispatcher] = useFilters();
    const [subcategoriesOptions, setSubcategoriesOptions] = useState([]);

    useEffect(() => {
        if (!filters.items.arrangeSelectedCategory) return;
            setSubcategoriesOptions(
                getProcessedSubcategoriesWithOptions(filters.items.arrangeSelectedCategory.subcategories, { withAll: false } )
            );
    }, [filters.items.arrangeSelectedCategory]);

    useEffect(() => {
        if(!filters.items.arrangeSelectedSubcategory) return;
        const categoriesMap = categoryOptions.reduce((acc, curr) => ({ ...acc, [curr.value]: true }), {});
        const newList = data.list.filter((p) =>{
            if (filters.items.arrangeSelectedSubcategory.value === -2) {
                return p.categories.some((c) => filters.items.arrangeSelectedCategory.value === c.category) &&
                    p.categories.every((c) => categoriesMap[c.category] === true);
            }
            return p.categories.some(({ category }) => category === filters.items.arrangeSelectedSubcategory.value);
        }).sort((a, b)=> {
            let catA, catB;
            if(filters.items.arrangeSelectedSubcategory.value === -2){
                catA = a.categories.find(({ category }) => category === filters.items.arrangeSelectedCategory.value)
                catB = b.categories.find(({ category }) => category === filters.items.arrangeSelectedCategory.value)
            } else {
                catA = a.categories.find(({ category }) => category === filters.items.arrangeSelectedSubcategory.value)
                catB = b.categories.find(({ category }) => category === filters.items.arrangeSelectedSubcategory.value)
            }

            if(!catA.position && !!catB.position) return 1;
            if(!!catA.position && !catB.position) return -1;
            return catA.position - catB.position;
        });

        setList(newList);
    }, [data.list, filters.items.arrangeSelectedSubcategory]);

    const onSelectCategory = (selected) => {
        filtersDispatcher.arrangeItemsSetSelectedCategory(selected);
    };

    const onSelectSubcategory = (selected) => {
        filtersDispatcher.arrangeItemsSetSelectedSubcategory(selected);
    };

    const processedCategories = useMemo(() => {
        return getProcessedCategories(categories);
    }, [categories]);

    const [categoryOptions, selectedCategory] = useTranslatedFilterSelect(
        processedCategories,
        filters.items.arrangeSelectedCategory,
        filtersDispatcher.arrangeItemsSetSelectedCategory
    );

    const [subcategoryOptions, selectedsubcategory] = useTranslatedFilterSelect(
        subcategoriesOptions,
        filters.items.arrangeSelectedSubcategory,
        filtersDispatcher.arrangeItemsSetSelectedSubcategory
    );

    return (
        <FiltersContainer>
            <Dropdown
                className='filter-dropdown'
                labelProps={{ label: translate('Category') }}
                selectProps={{
                    onChange: onSelectCategory,
                    options: categoryOptions,
                    placeholder: '',
                    value: selectedCategory,
                }}
            />
            <Dropdown
                className='filter-dropdown'
                labelProps={{ label: translate('Subcategory') }}
                selectProps={{
                    onChange: onSelectSubcategory,
                    options: subcategoryOptions,
                    placeholder: '',
                    value: selectedsubcategory,
                }}
            />
        </FiltersContainer>
    );
};
export default Filters;